import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Checkbox } from '@mui/material';
import { Column } from 'primereact/column';
import { StyledBoxTable } from '../../../components/layout/main/mainStyles';
import { LoadingRowsComponent } from '../../../components/commons/LoadingRows/LoadingRows';
import { PartNumberTemplateTemplateProps } from './partNumberTemplateProps';
import { styledColumnHeaderCheckbox } from '../../../components/layout/main/mainStyles';

export const PartNumberTemplate = ({
  isLoading,
  isSuccess,
  allPartNumber,
  selectedItems,
  setSelectedItems
}: PartNumberTemplateTemplateProps) => {
  const getHeaderCheckbox = () => {
    return (
      <Checkbox
        className="p-checkbox"
        style={{
          visibility: selectedItems.length ? 'visible' : 'hidden'
        }}
        checked={
          (allPartNumber && selectedItems && selectedItems.length > 0) ?? false
        }
        onChange={() => {
          setSelectedItems([]);
        }}
      />
    );
  };
  return (
    <StyledBoxTable>
      {isLoading && <LoadingRowsComponent />}
      {isSuccess && allPartNumber && (
        <DataTable
          selectionMode="multiple"
          metaKeySelection
          selection={selectedItems}
          value={allPartNumber ?? []}
          size="small"
          scrollable
          scrollHeight="flex"
          onSelectionChange={(e) => setSelectedItems(e.value)}
          paginator={allPartNumber && allPartNumber.length >= 50}
          selectionPageOnly
          rows={50}
          rowsPerPageOptions={[5, 10, 20, 50]}
          tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
          className="mt-3"
          rowHover
        >
          <Column
            selectionMode="multiple"
            headerStyle={styledColumnHeaderCheckbox}
            header={getHeaderCheckbox}
            frozen
          />
          <Column field="partNumber" header="Part Number" sortable />
          <Column field="product" header="Product" sortable />
          <Column field="series" header="Series" sortable />
          <Column field="model" header="Model" sortable />
          <Column field="sku" header="Sku" sortable />
          <Column
            field="startSerialNumber"
            header="Start Serial Number"
            sortable
          />
          <Column field="description" header="Description" sortable />
        </DataTable>
      )}
    </StyledBoxTable>
  );
};
